<template>
  <div id="Content">
    <div class="publishPreviewNav">
      <img src="../../../../img/previewLogo.png" alt="" />
      <span class="publishNavTitle">大百科</span>
    </div>
    <!-- 页面标题 -->
    <div class="contentBox" id="mediaContent">
      <div class="articleTitle">
        <p>{{ articleTitle }}</p>
      </div>
      <div class="basicInfo">
        <div class="moduleTitle">基本信息</div>
        <div class="basicContent">
          <div class="authorText">
            <p><span>来源：</span>{{ basicInfo.sourceInfo.name }}</p>
          </div>
          <div class="authorText">
            <p><span>分支：</span>{{ basicInfo.subjectInfo.subBranch }}</p>
          </div>
          <div class="authorText">
            <p><span>关键字：</span>{{ basicInfo.keywords }}</p>
          </div>
          <div class="authorText">
            <p><span>点击量：</span>{{ basicInfo.hits }}</p>
          </div>
          <div class="authorText">
            <p><span>更新时间：</span>{{ getTime }}</p>
          </div>
        </div>
      </div>
      
      <div class="qaContentBox">
        <div class="moduleTitle">答案</div>
        <div class="qaContent" v-html="qaContent"></div>
      </div>
      <div class="resourceBox" v-if="basicInfo.images">
        <div class="moduleTitle">多媒体内容</div>
        <div class="resourceContent"  v-html="basicInfo.images"></div>
      </div>
      <!-- <div class="mainContent">
        <div class="moduleTitle">多媒体内容</div>
        <div class="previewContent">
          <div class="imgPreviewBox" v-if="currentType == 1">
            <img class="previewImg" :src="imgUrl" />
            <p>{{ articleTitle }}</p>
          </div>
          <div class="imgPreviewBox" v-if="currentType == 2">
            <video class="previewVideo" controls>
              <source :src="videoUrl" type="video/mp4" />
            </video>
            <p>{{ articleTitle }}</p>
          </div>
          <div class="imgPreviewBox" v-if="currentType == 3">
            <audio controls style="width: 50%">
              <source :src="audioUrl" type="audio/mp3" />
            </audio>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  data() {
    return {
      data: [],
      qaContent:"",
      menuData: [],
      relatedResourceData: [],
      articleTitle: "",
      wzg: "",
      zjrjj: "",
      currentType: 1,

      basicInfo: {},
      zjrInfo: {},
      isbasicInfoEmpty: false,
      isZjrInfoEmpty: false,
      imageNote: "",
      //   authorText: "",
      //   sourceInfo: "",
      description: "",
      //   headTextList: [],
      //   summaryFieldsList: [],

      imgUrl: "",
      videoUrl: "",
      audioUrl: "",
      props: {
        label: "name",
        children: "children",
        isLeaf: "leaf",
      },
      getTime:'',
    };
  },
  props: {
    topIndex: String,
  },
  mounted() {
    let that = this;
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
    var qaUrl = "",params = {};


    if(this.$route.query.version){
      qaUrl = '/zyk/qa/selectByQaIdAndVersion';
      params = {qaId:this.$route.query.id,version:this.$route.query.version};
    }else{
      qaUrl = '/zyk/qa/selectByQaId';
      params = {qaId:this.$route.query.id};
    }
    $.ajax({
      type: "GET",
      dataType: "json",
      url: qaUrl,
      data: params,
      contentType: "application/json;charset=utf-8",
      success: function (response) {
        if (response.code == 200) {
          var data = response.obj;
          that.basicInfo = response.obj;
          
          // if (data.resourceInfoExtend.description != null) {
          //   that.description = data.resourceInfoExtend.description;
          //   setTimeout(function () {
          //     $(".descTextContent").html(data.resourceInfoExtend.description);
          //   }, 2000);
          // }
          that.articleTitle = data.name;
          that.qaContent = data.content;

          that.getTime = that.basicInfo.modifyTime?that.basicInfo.modifyTime:that.basicInfo.addTime;

          setTimeout(function () {
             var contentSingleImg = $(".resourceContent .qa-img");
             var currentHtml = "";
             contentSingleImg.each(function (index, item) {
                currentHtml += "<p class='pic-qa-top'><img src='"+$(item).attr('logopath')+"'/></p>";
                // if($(item).attr('title') != 'null'||''){
                //   console.log("有图片标题");
                // }else{
                //   console.log("无图片标题");
                // }
                // 若有图题则显示图题
                var titleSingle = $(item).attr("title");
                if (titleSingle && titleSingle != "") {
                  var imgWidth = $(item).width();
                  currentHtml += "<p class='pic-single-font' style='text-align:center;padding: 10px 0;margin-top: -5px;width:" +
                        imgWidth +
                        "px'>" +
                        titleSingle +
                        "</p>"
                }
                if($(item).attr('note')){
                  currentHtml += "<p class='pic-qa-bottom'>"+$(item).attr('note')+"</p>";
                }
            });

            $(".resourceContent").html(currentHtml);
          
           contentSingleImg.on({}).viewer({
                url: 'httpPath',
                navbar: false,
                title: true
            })
          }, 50);

          setTimeout(function () {
            var pWidth = $(".imgPreviewBox img").width();
            $(".imgPreviewBox p").width(pWidth);
          }, 50);
        } else {
          that.$message({
            message: response.msg,
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      },
      error: function (data) {
        console.log(data);
      },
    });
    
    
  },
  methods: {
    getChild() {
      console.log(this.index);
    },
    changePlayStatus(status) {
      //获取子组件的播放状态
      if (status) {
        this.disabledShot = false;
      } else {
        this.disabledShot = true;
        this.sourceUrl = "";
        this.checkedPontsName = "";
      }
    },
  },
};
</script>

<style>
#mediaContent{
    margin-bottom: 100px;
}

#mediaContent .previewContent {
  text-align: center;

}

#mediaContent .previewVideo {
  width: 100%;
}

.pageTitle {
  line-height: 100px;
  color: #fff;
  font-size: 24px;
  padding-left: 100px !important;
  background: #666;
  height: auto !important;
}

/* #Content .contentBox {
  padding: 0 20%;
} */

#Content .contentBox .articleTitle p {
  font-size: 40px;
  padding: 20px 0;
  color: #000;
  font-weight: bolder;
}

#Content .contentBox .previewContent p {
  /* line-height: 2.5em; */
  font-size: 16px;
}
/* #Content .contentBox .previewContent {
  padding: 20px 0;
} */

#Content .contentBox .moduleTitle {
  font-size: 22x;
  font-weight: bolder;
  border-bottom: 1px solid rgba(35, 77, 60, 0.4);
  color: #295a46;
  padding-bottom: 10px;
  margin-bottom: 20px;
  margin-top: 30px;
}

#Content .contentBox .mainContent {
  margin-top: 20px;
  margin-bottom: 50px;
}

#Content .contentBox .basicInfo .basicContent {
  overflow: auto;
}

#Content .contentBox .basicInfo .basicContent::after {
  content: "";
  display: inline-block;
  clear: both;
}

#Content .contentBox .basicInfo .basicContent div {
  float: left;
  width: 50%;
  margin-bottom: 20px;
}

#Content .contentBox .basicInfo .basicContent p span {
  font-weight: bolder;
}

.infoText {
  overflow: auto;
}

.infoText::after {
  content: "";
  display: inline-block;
  clear: both;
}

.infoText p {
  float: left;
  width: 50%;
  margin-bottom: 20px;
}

.infoText p span {
  font-weight: bolder;
}

.imgPreviewBox p {
  border: 1px solid #dcdfe6;
  border-bottom: 2px solid #50b58d;
  margin: 0 auto;
  margin-top: -5px;
}

.wzgContent,
.zjrjjContent {
  text-indent: 2em;
  line-height: 2.1em;
}

.pic-qa-top{
  text-align: center;
}

.qaContent .left{
  text-align: left;
}
.qaContent .right{
  text-align: right;
}
.qaContent .center{
  text-align: center;
}

.qaContent{
  text-indent: 2em;
  line-height: 2em;
}
</style>
